import { CredentialStatus } from './credentialStatus';

export interface CustomPersonCredentialStatusDefinition {
  id: string;
  credentialDefinitionId: string;
  credentialStatus: CredentialStatus;
  labelId: string;
  label: string;
  color: CredentialStatusLabelColor;
  preventStatusChanges: boolean;
}

export enum CredentialStatusLabelColor {
  Green,
  Yellow,
  Red,
  Blue,
  Gray,
}
